let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iBcW2")).then(() => parcelRequire('kNA4T'));